<template>
  <Layout
    username="Agent"
    current-page="Edit Profile"
    link-to-edit="/agent-dashboard/edit-profile"
  >
    <template slot="menuItems">
      <li
        v-for="{ title, icon, path } in menu"
        :key="title"
        class="nav-item"
      >
        <MenuItems
          :menu-item="title"
          :icon-menu="icon"
          :to-where="path"
        />
      </li>
    </template>
    <template slot="content">
      <div class="jumbotron justify-content-center d-sm-none d-md-block col-lg-9 mr-sm-0 ml-sm-0">
        <div class="row">
          <div class="col-sm-12 col-lg-5 px-4">
            <img
              src="@/assets/images/avatar.svg"
              alt="profile pic"
              height="200"
              width="200"
              class="img-sm rounded-circle border align-middle"
            >
            <h2 class="mt-3">
              Luka Jean
            </h2>
            <h5><small>Agent</small></h5>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm-block btn-sm mt-3"
            >
              Upload picture
            </button>
            <button
              type="button"
              class="btn btn-danger btn-sm btn-sm-block mt-3 ml-2"
            >
              Remove picture
            </button>
          </div>
          <div class="col-sm-12 col-lg-7  border-left">
            <h3><small>Basic Info</small></h3>
            <ValidationObserver v-slot="{invalid}">
              <form>
                <ValidationProvider
                  v-for="input in inputs"
                  :key="input.name"
                  v-slot="{errors}"
                  mode="aggressive"
                  :rules="input.rules"
                  persist
                >
                  <div class="form-group">
                    <label :for="input.name">{{ input.label }}</label>
                    <input
                      v-model="input.value"
                      :name="input.name"
                      :type="input.type"
                      :placeholder="input.placeholder"
                      class="form-control"
                      :class="{'is-invalid': errors[0]}"
                    >
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </div>
                </ValidationProvider>
                <div class="d-flex flex-row-reverse mt-3">
                  <button
                    type="submit"
                    class="btn btn-primary p2"
                    :disabled="invalid"
                  >
                    Save
                    <span
                      v-if="wait"
                      class="spinner-grow spinner-grow-sm text-light"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </span>
                  </button>
                </div>
              </form>
            </ValidationObserver>
            <hr>
            <h3><small>Security</small></h3>
            <ValidationObserver v-slot="{invalid}">
              <form>
                <ValidationProvider
                  v-slot="{errors}"
                  mode="aggressive"
                  rules="required|min:6"
                  persist
                >
                  <div class="form-group">
                    <label for="old password">Old password</label>
                    <input
                      type="password"
                      name="old password"
                      class="form-control"
                      :class="{'is-invalid': errors[0]}"
                      placeholder="Old password"
                    >
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  v-slot="{errors}"
                  mode="aggressive"
                  rules="required|min:6"
                  persist
                >
                  <div class="form-group">
                    <label for="new password">New password</label>
                    <input
                      type="password"
                      name="new password"
                      class="form-control"
                      :class="{'is-invalid': errors[0]}"
                      placeholder="New password"
                    >
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  v-slot="{errors}"
                  mode="aggressive"
                  rules="required|min:6"
                  persist
                >
                  <div class="form-group">
                    <label for="confirm new password">Confirm new password</label>
                    <input
                      type="password"
                      name="confirm new password"
                      class="form-control"
                      :class="{'is-invalid': errors[0]}"
                      placeholder="Confirm new password"
                    >
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </div>
                </ValidationProvider>
                <div class="d-flex flex-row-reverse mt-3">
                  <button
                    type="submit"
                    class="btn btn-primary p2"
                    :disabled="invalid"
                  >
                    Change password
                    <span
                      v-if="wait"
                      class="spinner-grow spinner-grow-sm text-light"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </span>
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </template>
  </Layout>
</template>
<script>
import Layout from "../../components/Layout";
import MenuItems from "../../components/MenuItems";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  name: "Editagent",
  components: {
    Layout,
    MenuItems,
    ValidationProvider,
    ValidationObserver,
  },
  data () {
    return {
      menu: [
        {
          title: "Record Sale",
          icon: "fa fa-cash-register",
          path: "/agent-dashboard",
        },
        {
          title: "Drafted Records",
          icon: "fa fa-edit",
          path: "/agent-dashboard/drafts",
        },
        {
          title: "View Sales",
          icon: "fa fa-table",
          path: "/agent-dashboard/view-sales",
        },
      ],
      inputs: [
        {
          label: "Name",
          name: "admin name",
          type: "text",
          rules: "required",
          value: "",
          placeholder: "Name"
        },
        {
          label: "Username",
          name: "username",
          type: "text",
          rules: "required",
          value: "",
          placeholder: "Username"
        },
        {
          label: "Email",
          name: "email",
          type: "email",
          rules: "required|email",
          value: "",
          placeholder: "Email"
        },
        {
          label: "Phone number",
          name: "phone number",
          type: "tel",
          rules: "required|phone|digits:10",
          value: "",
          placeholder: "Phone number"
        },
      ],
      name: '',
      role: ''
    }
  }
}
</script>
<style scoped>
.nav-item {
  cursor: pointer;
}

.nav-item .nav-link:hover {
  color: #8bc34a;
}

.jumbotron {
  overflow-x: scroll;
}
</style>